import { render } from "./UpdateNews.vue?vue&type=template&id=4f9e8c23&ts=true"
import script from "./UpdateNews.vue?vue&type=script&lang=ts"
export * from "./UpdateNews.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/shunta/website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__